'use client';

import React from 'react';

import styles from './MainArea.module.css';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const MainArea = ({ children, className }: Props) => {
  return (
    <div className={`${styles.mainArea} ${className || ''}`}>
      {children}
    </div>
  );
};

export default MainArea;
